export const STUDENTSESSIONS = {
  studentIntroLogisticsandCommunityCareDiscussionHandoutIcebreakerbingoect: {
    room: 'ball',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '8:30am-9:00am',
    name: '',
    topicS:
      'Intro/Logistics and Community Care Discussion/Hand out Icebreaker/bingo/ect.',
    topicL:
      'Intro/Logistics and Community Care Discussion/Hand out Icebreaker/bingo/ect.',
    presenter: 'Student Reps.',
    id: 'studentIntroLogisticsandCommunityCareDiscussionHandoutIcebreakerbingoect',
  },
  studentPlasmaPhysics: {
    room: 'ball',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '9:00am-9:20am',
    name: '',
    topicS: 'Plasma Physics',
    topicL: 'Plasma Physics',
    presenter: 'Oshina Jagtap',
    id: 'studentPlasmaPhysics',
  },
  studentSpaceWeather: {
    room: 'ball',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '9:20am-9:40am',
    name: '',
    topicS: 'Space Weather',
    topicL: 'Space Weather',
    presenter: 'Vincent Ledvina',
    id: 'studentSpaceWeather',
  },
  'coffee-break-9:40a': {
    room: '',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '9:40am-10:00am',
    name: 'Coffee Break',
    id: 'coffee-break-9:40a',
  },
  studentCEDARRegime1MLT: {
    room: 'ball',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '10:00am-10:20am',
    name: '',
    topicS: 'CEDAR Regime 1 (MLT)',
    topicL: 'CEDAR Regime 1 (MLT)',
    presenter: 'Jackson Jandreau',
    id: 'studentCEDARRegime1MLT',
  },
  studentCEDARRegime2IT: {
    room: 'ball',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '10:20am-10:40am',
    name: '',
    topicS: 'CEDAR Regime 2 (IT)',
    topicL: 'CEDAR Regime 2 (IT)',
    presenter: 'Brenna Royersmith',
    id: 'studentCEDARRegime2IT',
  },
  studentMagIonoThermCoupling: {
    room: 'ball',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '10:40am-11:00am',
    name: '',
    topicS: 'Mag-Iono-Therm Coupling',
    topicL: 'Mag-Iono-Therm Coupling',
    presenter: 'Jodie McLennan',
    id: 'studentMagIonoThermCoupling',
  },
  'coffee-break-(meditation)-11:00': {
    room: '',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '11:00am-11:20am',
    name: 'Coffee Break (Meditation)',
    presenter: 'Bhagyashree Wahgule',
    id: 'coffee-break-(meditation)-11:00',
  },
  studentGEMRegime1IMAG: {
    room: 'ball',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '11:20am-11:40am',
    name: '',
    topicS: 'GEM Regime 1 (IMAG)',
    topicL: 'GEM Regime 1 (IMAG)',
    presenter: "Declan O'Brien",
    id: 'studentGEMRegime1IMAG',
  },
  studentGEMRegime2Magnetosphere: {
    room: 'ball',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '11:40am-12:00pm',
    name: '',
    topicS: 'GEM Regime 2 (Magnetosphere)',
    topicL: 'GEM Regime 2 (Magnetosphere)',
    presenter: 'Anika Dujakovich',
    id: 'studentGEMRegime2Magnetosphere',
  },
  'student-lunch-12:00': {
    room: 'ballJr',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '12:00pm-1:30pm',
    name: 'Student Lunch',
    presenter: '',
    id: 'student-lunch-12:00',
  },
  studentCEDARTrackGroundBasedInstruments: {
    room: '318',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '1:20pm-2:20pm',
    name: 'Afternoon Session 1',
    topicS: 'CEDAR Track: Ground Based Instruments',
    topicL: 'CEDAR Track: Ground Based Instruments',
    presenter:
      'Asti Bhatt (ISR), Kylee Branning (FPI), Simon Shepherd (SuperDARN)',
    id: 'studentCEDARTrackGroundBasedInstruments',
  },
  studentGEMTrackModeling: {
    room: '308',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '1:20pm-2:20pm',
    name: 'Afternoon Session 1',
    topicS: 'GEM Track: Modeling',
    topicL: 'GEM Track: Modeling',
    presenter: 'Roger Varney, Jack Wang (CCMC)',
    id: 'studentGEMTrackModeling',
  },
  studentCareerAdvancementTrackProposalwritingworkshop: {
    room: '309',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '1:20pm-2:20pm',
    name: 'Afternoon Session 1',
    topicS: 'Career Advancement Track: Proposal writing workshop',
    topicL: 'Career Advancement Track: Proposal writing workshop',
    presenter: 'Komal Kumari, Lindsay Goodwin',
    id: 'studentCareerAdvancementTrackProposalwritingworkshop',
  },
  studentAppliedSoftSkillsTrackCEDARGEMdatabases: {
    room: '319',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '1:20pm-2:20pm',
    name: 'Afternoon Session 1',
    topicS: 'Applied + Soft Skills Track: CEDAR/GEM databases',
    topicL: 'Applied + Soft Skills Track: CEDAR/GEM databases',
    presenter: 'Katherine Cariglia (Madrigal), Jesper Gjerloev (SuperMAG)',
    id: 'studentAppliedSoftSkillsTrackCEDARGEMdatabases',
  },
  'coffee-break-2:20p': {
    room: '',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '2:20pm-2:40pm',
    name: 'Coffee Break',
    id: 'coffee-break-2:20p',
  },
  studentCEDARTrackModeling: {
    room: '318',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '2:40pm-3:40pm',
    name: 'Afternoon Session 2',
    topicS: 'CEDAR Track: Modeling',
    topicL: 'CEDAR Track: Modeling',
    presenter: 'Matt Zettergren (GEMINI), Aaron Ridley (GITM)',
    id: 'studentCEDARTrackModeling',
  },
  studentGEMTrackDataAnalysisMethodsandTools: {
    room: '308',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '2:40pm-3:40pm',
    name: 'Afternoon Session 2',
    topicS: 'GEM Track: Data Analysis Methods and Tools',
    topicL: 'GEM Track: Data Analysis Methods and Tools',
    presenter: 'Hyunju Connor (Machine Learning)',
    id: 'studentGEMTrackDataAnalysisMethodsandTools',
  },
  studentCareerAdvancementTrackFutureofSpaceMissions: {
    room: '309',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '2:40pm-3:40pm',
    name: 'Afternoon Session 2',
    topicS: 'Career Advancement Track: Future of Space Missions',
    topicL: 'Career Advancement Track: Future of Space Missions',
    presenter: 'Scott Bailey (DYNAMIC), Douglas Rowland (GDC)',
    id: 'studentCareerAdvancementTrackFutureofSpaceMissions',
  },
  studentAppliedSoftSkillsTrackScienceCommunication: {
    room: '319',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '2:40pm-3:40pm',
    name: 'Afternoon Session 2',
    topicS: 'Applied + Soft Skills Track: Science Communication',
    topicL: 'Applied + Soft Skills Track: Science Communication',
    presenter:
      'Claire Gasque (Giving Talks), Madeline Evans (Poster Presentations)',
    id: 'studentAppliedSoftSkillsTrackScienceCommunication',
  },
  'coffee-break-3:40p': {
    room: '',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '3:40pm-4:00pm',
    name: 'Coffee Break',
    id: 'coffee-break-3:40p',
  },
  studentCEDARTrackSpacebasedInstruments: {
    room: '318',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '4:00pm-5:00pm',
    name: 'Afternoon Session 3',
    topicS: 'CEDAR Track: Space-based Instruments',
    topicL: 'CEDAR Track: Space-based Instruments',
    presenter: 'Colin Triplett (ICON), Joanne Wu (Swarm), Jia Yue (SABER)',
    id: 'studentCEDARTrackSpacebasedInstruments',
  },
  studentGEMTrackInstruments: {
    room: '308',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '4:00pm-5:00pm',
    name: 'Afternoon Session 3',
    topicS: 'GEM Track: Instruments',
    topicL: 'GEM Track: Instruments',
    presenter: 'Sarah Vines',
    id: 'studentGEMTrackInstruments',
  },
  studentCareerAdvancementTrackHowtobecomeaPIofyourownmission: {
    room: '309',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '4:00pm-5:00pm',
    name: 'Afternoon Session 3',
    topicS: 'Career Advancement Track: How to become a PI of your own mission',
    topicL: 'Career Advancement Track: How to become a PI of your own mission',
    presenter:
      'Ed Thiemann (Being a PI), Stephen Kaeppler (How to Design a Mission)',
    id: 'studentCareerAdvancementTrackHowtobecomeaPIofyourownmission',
  },
  studentAppliedSoftSkillsTrackDatavisualization: {
    room: '319',
    groups: [],
    isJoint: false,
    date: 'Sunday, June 22',
    day: 'student',
    time: '4:00pm-5:00pm',
    name: 'Afternoon Session 3',
    topicS: 'Applied + Soft Skills Track: Data visualization',
    topicL: 'Applied + Soft Skills Track: Data visualization',
    presenter: 'Jessica Norrell, Lindsay Goodwin',
    id: 'studentAppliedSoftSkillsTrackDatavisualization',
  },
}
export const STUDENTSESSIONSLIST = {
  student: [
    [
      'studentIntroLogisticsandCommunityCareDiscussionHandoutIcebreakerbingoect',
    ],
    ['studentPlasmaPhysics'],
    ['studentSpaceWeather'],
    ['coffee-break-9:40a'],
    ['studentCEDARRegime1MLT'],
    ['studentCEDARRegime2IT'],
    ['studentMagIonoThermCoupling'],
    ['coffee-break-(meditation)-11:00'],
    ['studentGEMRegime1IMAG'],
    ['studentGEMRegime2Magnetosphere'],
    ['student-lunch-12:00'],
    [
      'studentCEDARTrackGroundBasedInstruments',
      'studentGEMTrackModeling',
      'studentCareerAdvancementTrackProposalwritingworkshop',
      'studentAppliedSoftSkillsTrackCEDARGEMdatabases',
    ],
    ['coffee-break-2:20p'],
    [
      'studentCEDARTrackModeling',
      'studentGEMTrackDataAnalysisMethodsandTools',
      'studentCareerAdvancementTrackFutureofSpaceMissions',
      'studentAppliedSoftSkillsTrackScienceCommunication',
    ],
    ['coffee-break-3:40p'],
    [
      'studentCEDARTrackSpacebasedInstruments',
      'studentGEMTrackInstruments',
      'studentCareerAdvancementTrackHowtobecomeaPIofyourownmission',
      'studentAppliedSoftSkillsTrackDatavisualization',
    ],
  ],
}
